export const About = () => {
  return(
    <div className='container'>
    <h1>sobre</h1>
        <p>o <strong>comandos.dev</strong> é uma plataforma que centraliza diversos comandos essenciais usados pela
          comunidade de desenvolvedores. o objetivo principal é reunir essas informações de forma prática e acessível em
          um único lugar.</p>

        <p>é possível que você perceba a ausência de algum comando ou até mesmo de algum sistema que utiliza. Nosso
          intuito é armazenar o maior número possível de informações para tornar a jornada dos desenvolvedores
          iniciantes
          mais fácil, evitando que se percam em excesso de dados desnecessários e confusos. A proposta é oferecer
          simplicidade, como o próprio site. se tiver sugestões de melhorias ou quiser apoiar essa iniciativa, não
          hesite
          em nos contatar; sua colaboração será muito valiosa para nós. <a href="/">confira onde nos encontrar</a>.</p>
    </div>
  );
};